import React from 'react'
import {
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions
} from 'material-ui/Card'
import { Button } from 'components'
import { AnalyticsUtils, Enum } from 'utils'

const JOB_TYPE = "Blog"

export default class BlogFixesCard extends React.Component {
  static propTypes = {
    source: React.PropTypes.string
  }

  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  componentDidMount() {
    AnalyticsUtils.recommendedJobViewed(JOB_TYPE)
  }

  handleClickedLearnMore() {
    AnalyticsUtils.learnMoreButtonClicked(JOB_TYPE)
  }

  utmMedium(){
    if (this.props.source === Enum.BlimponLinkLocations.getItFixedPage) {
      return 'get%20it%20fixed';
    } else {
      return 'app%20dashboard';
    }
  }

  linkUrl(){
    let url = 'https://www.pluginuseful.com/e-commerce-content-marketing-services/?utm_source=plug%20in%20seo%20app&utm_medium='+this.utmMedium()+'&utm_campaign=blogging%20service';
    return url;
  }

  render() {
    return (
      <Card key='blogfixes' className='recommended-job-card' style={{borderRadius: 10}} onTouchTap={ () => { location.href = 'https://www.blimpon.com/pages/monthly-blogging-packages' } }>
        <CardMedia>
          <img src='https://dropshare-daniel.s3-eu-west-1.amazonaws.com/0SPmlvGZvQ.png' style={{borderRadius: '10px 10px 0 0'}}/>
        </CardMedia>
        <CardTitle
          title={<h2 className="small-spacing2">Blogging</h2>}
          subtitle='$70 - $100 per post'
          style={{paddingBottom: 12}}
        />
        <CardText style={{padding: '0 16px'}}>
          <ul className='icon-font-list'>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>
              Get your store found online, boost rankings, attract more visitors, and increase sales with content that ranks and converts.
            </li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Well-structured, SEO-optimized and written to improve visibility</li>
            <li className='icon-font-list__list-item icon-font-list__list-item--check'>Quality, researched writing by a native English speaker</li>
            
          </ul>
        </CardText>
        <CardActions style={{padding: 16}}>
          <Button
            label="Learn More"
            buttonType="secondary"
            href={this.linkUrl()}
            onTouchTap={::this.handleClickedLearnMore}
          />
        </CardActions>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/jobs/BlogFixesCard.js